import styled from '@xstyled/styled-components'

export const StyledQRCodeSharePanel = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: 24
})

export const StyledQRCodeDisplayContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'grey.l4',
  padding: 50,
  borderRadius: 8
})

export const StyledQRCodeSharePanelFooter = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end'
})
